"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeCell = void 0;
const react_1 = __importStar(require("react"));
const date_fns_1 = require("date-fns");
const locale_context_1 = require("../../../common/locale/locale-context");
const text_cell_1 = require("./text-cell");
const date_utils_1 = require("../../../utils/date-utils");
exports.TimeCell = react_1.memo(function TimeCell(props) {
    const { locale } = react_1.useContext(locale_context_1.LocaleContext);
    const parsed = date_utils_1.parseISOTimeSafe(props.value);
    const date = parsed ? date_fns_1.format(parsed, locale.timeFormat) : '';
    return react_1.default.createElement(text_cell_1.TextCell, Object.assign({}, props, { value: date }));
});
//# sourceMappingURL=time-cell.js.map